export const getUniqueKey = () => Math.random().toString(36).replace(/0./g, '');